import React, { useState } from "react";
import { Toast } from "../../../config/Toast";
import { toast } from "react-toastify";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import Button from "../../../components/Button";
import InputGroup from "../../../components/InputGroup";
import ButtonDropdown from "../../../components/ButtonDropdown";
import moment from "moment";

function ActionCashReceipt({ rangeDate, onDateChange, onPost, onSearch, loadingPost }) {
  const notifyFailed = (message) => toast.error(message, Toast);

  const getWeeksOfMonth = (year, month) => {
    const weeks = [];
    let current = moment(`${year}-${month}-01`).startOf("month");
    while (current.day() !== 4) current.add(1, "day");
    while (current.month() + 1 === month) {
      const start = current.clone();
      const end = current.clone().add(6, "days");
      weeks.push([start.toDate(), end.toDate()]);
      current.add(7, "days");
    }

    return weeks;
  };

  const currentYear = moment().year();
  const currentMonth = moment().month() + 1;
  const weeks = getWeeksOfMonth(currentYear, currentMonth);

  const handleSelectWeek = (index) => {
    const week = weeks[index];
    if (!week) return notifyFailed("Minggu tidak ditemukan.");

    onDateChange(week);
    toast.success(`Tanggal terpilih: ${moment(week[0]).format("DD MMM")} - ${moment(week[1]).format("DD MMM")}`, Toast);
  };

  const handleSearchInput = (value) => {
    if (onSearch) onSearch(value);
  };

  const dropdown = [
    { name: "Minggu 1", clickFunction: () => handleSelectWeek(0) },
    { name: "Minggu 2", clickFunction: () => handleSelectWeek(1) },
    { name: "Minggu 3", clickFunction: () => handleSelectWeek(2) },
    { name: "Minggu 4", clickFunction: () => handleSelectWeek(3) },
    { name: "Minggu 5", clickFunction: () => handleSelectWeek(4) },
  ];

  return (
    <div className="d-flex flex-column justify-content-end align-items-end w-100 h-100 p-0 m-0 gap-3">
      <div className="d-flex justify-content-space-between align-items-end w-100 h-100 gap-2">
        <div className="w-30">
          <h6 className="fw-bold white-space-nowrap">Pilih Rentang Tanggal</h6>
          <Flatpickr
            value={rangeDate}
            options={{ mode: "range", dateFormat: "d-m-Y" }}
            onChange={(dates) => onDateChange(dates)}
            className="form-control"
            placeholder="Pilih Tanggal Awal dan Akhir"
          />
        </div>
        <ButtonDropdown button="btn-primary" title="Shortcut Date" dropdown={dropdown} />
        <div className="flex-1"></div>
        <Button
          button="btn-warning btn-md w-20"
          title={loadingPost ? "Posting..." : "Posting to Cicilan"}
          onClick={onPost}
        />
      </div>

      <div className="w-40 m-0 p-0">
        <InputGroup button="btn-dark" icon="fa fa-search" placeholder="Cari Worker ID / Worker Name" searchHandler={handleSearchInput} />
      </div>
    </div>
  );
}

export default ActionCashReceipt;
